// 阿里云上传的配置项，后续会提供从项目main.js内配置传过来的功能
let obj = {
  region: 'oss-cn-beijing',
  accessKeyId: 'LTAI4G15LcBk4UQ9icCL7S9h',
  accessKeySecret: 'B1FZ3S9eScFyp2PKEOWkxaJjJvUFFV',
  bucket: 'rektec'
};

export default obj;



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/upload/ossClientConfig.js